// extracted by mini-css-extract-plugin
export default {"MainNewsContainer":"MainNews_MainNewsContainer__8StdF","Description":"MainNews_Description__MmyHl","Badge":"MainNews_Badge__IUKiq","ScrollButtons":"MainNews_ScrollButtons__UzNbj"};